




import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class MirrorCamera extends Vue {
  public video!: HTMLVideoElement;

  public mounted() {
    const medias = {
      audio: false,
      video: {
        facingMode: {
          exact: "user",
        },
      },
    };
    this.video = this.$refs.video as HTMLVideoElement;
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      navigator.mediaDevices
        .getUserMedia(medias)
        .then((stream) => {
          this.video.srcObject = stream;
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }
}
